import { useMutation } from 'react-query';
import { offersService, removeCache, saleService } from '../../../services';
import { IdProps, SendOfferProps } from '../../../types';

export const useBuyMarketplaceMutation = () => {
  return useMutation(
    (props: IdProps[]) => {
      return saleService.buy(props);
    },
    {
      onSettled: () => {
        removeCache(['sale', 'key']);
      },
    },
  );
};

export const useSendOfferMarketplaceMutation = () => {
  return useMutation(
    (props: SendOfferProps) => {
      return offersService.send(props);
    },
    {
      onSuccess: () => {
        removeCache(['sale', 'key']);
      },
    },
  );
};
